import { Box, Chip, IconButton, List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import Add from "@mui/icons-material/Add";
import Check from "@mui/icons-material/Check";
import { useAsync2 } from "nate-react-api-helpers";
import { useState } from "react";
import { api } from "../../../api/API";
import { BottomSheet } from "./BottomSheet";

// MobileAssignees shows who the task is assigned to as chips, and adds more from the
// team's members. A task always has one, so the last chip has no remove button.
export function MobileAssignees(props: {
    team: number;
    value: number[];
    onChange: (value: number[]) => void;
}) {
    const [open, setOpen] = useState(false);

    const members = useAsync2(input => input.team ? api.teams.listMembers(input) : Promise.resolve(null),
        { team: props.team }, [props.team]);

    const list = members.result?.members || [];
    const selected = list.filter(member => props.value.includes(member.usr));

    return (
        <>
            <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 0.5 }}>
                {selected.map(member => (
                    <Chip key={member.usr} size="small" label={member.name}
                          onDelete={selected.length > 1
                              ? () => props.onChange(props.value.filter(id => id !== member.usr))
                              : undefined} />
                ))}
                <IconButton size="small" aria-label="Add assignee" onClick={() => setOpen(true)}>
                    <Add fontSize="small" />
                </IconButton>
            </Box>
            {members.LoadingOrErrorElement}

            <BottomSheet open={open} title="Assignees" onClose={() => setOpen(false)}>
                <List disablePadding>
                    {list.map(member => {
                        const on = props.value.includes(member.usr);

                        return (
                            <ListItemButton key={member.usr} onClick={() => {
                                if (!on) props.onChange(props.value.concat(member.usr));
                                else if (props.value.length > 1) props.onChange(props.value.filter(id => id !== member.usr));
                            }}>
                                <ListItemIcon sx={{ minWidth: 36 }}>{on && <Check fontSize="small" />}</ListItemIcon>
                                <ListItemText primary={member.name} secondary={member.email} />
                            </ListItemButton>
                        );
                    })}
                </List>
            </BottomSheet>
        </>
    );
}
